import SEO from "@/components/SEO";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { InnovationIcon, QualityIcon, CollaborationIcon, IntegrityIcon } from "../assets/svgs/AboutIcons";


export default function About() {
  const teamMembers = [
    {
      name: "Qaiser Ijaz",
      role: "CEO & Founder",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1750935817/Untitled_design_23_vku1wg.png",
      description: "Visionary entrepreneur with 10+ years of experience launching and scaling technology ventures. Leads strategic planning, fosters innovation, and drives business growth through impactful leadership and partnerships.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      },
      expertise: [
        "Strategic Planning",
        "Business Development",
        "Leadership & Vision",
        "Startup Ecosystems",
        "Financial Forecasting",
        "Market Disruption",
        "Investor Relations",
        "SaaS & Tech Startups",
        "Product Innovation"
      ],
      joinYear: 2019,
      funFact: "Plays chess competitively and reads startup pitch decks for fun"
    },
    {
      name: "Sarah Johnson",
      role: "Chief Technology Officer",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1751152798/Sarah_Johnson_Chief_tdq5tt.png",
      description: "Innovative CTO with deep expertise in cloud-native systems, scalable architecture, and cross-functional engineering leadership. Passionate about building tech teams that deliver high-performance and fault-tolerant applications.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      },
      expertise: [
        "System Architecture",
        "Cloud-Native Engineering",
        "Kubernetes & Containers",
        "DevOps & CI/CD",
        "Agile Transformation",
        "Tech Hiring & Mentorship",
        "Security Engineering",
        "Scalability & Resilience",
        "Cost Optimization (Cloud)"
      ],
      joinYear: 2020,
      funFact: "Climbed 3 mountains and contributes regularly to open-source cloud tools"
    },
    {
      name: "Zeshan Ejaz",
      role: "Senior Full Stack Engineer | Cloud & Cybersecurity Specialist",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1768654179/Navy_and_Blue_Modern_Professional_LinkedIn_Profile_Picture_2_xo9k8m.png",
      description: "Results-driven Senior Full Stack Engineer with 5+ years' experience building high-performance, scalable applications and mentoring development teams. Passionate about clean code, cloud optimization, and AI-driven solutions.",
      social: {
        linkedin: "https://www.linkedin.com/in/zeshanejaz/",
        twitter: "#",
        github: "https://github.com/zeshanejaz"
      },
      expertise: [
        "MERN Stack Development",
        "Cloud Architecture (AWS/Azure)",
        "Certified Ethical Hacker (CEH)",
        "Microservices & API Design",
        "CI/CD & DevOps (Docker, Jenkins, Kubernetes)",
        "AI/ML Integration & Data Analytics",
        "Performance Optimization",
        "System Design & Architecture",
        "Mentorship & Agile Team Leadership"
      ],
      joinYear: 2019,
      funFact: "Built an AI-powered music recommender that boosts user engagement by 85% 🚀"
    },
    {
      name: "Fatima Al-Hashimi",
      role: "Lead UI/UX Designer",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1751152294/generate_an_image_of_l3vxpz.png",
      description: "Creative UI/UX designer with 7+ years of experience crafting visually compelling and user-centered digital products. Specializes in intuitive interfaces, accessibility, and seamless design systems backed by user data.",
      social: {
        linkedin: "#",
        behance: "#",
        dribbble: "#"
      },
      expertise: [
        "UI/UX Design",
        "Wireframing & Prototyping",
        "User Research & Testing",
        "Figma & Adobe XD",
        "Design Systems",
        "Responsive Design",
        "Accessibility Standards",
        "Interaction Design",
        "Data-Driven UI"
      ],
      joinYear: 2021,
      funFact: "Creates digital art NFTs and runs a small online art gallery"
    },
    {
      name: "Omar Khan",
      role: "DevOps Engineer",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1751152517/Omar_Khan_rktbdb.png",
      description: "Highly skilled DevOps engineer with a focus on scalable cloud infrastructure, continuous deployment, and automation. Drives system reliability, infrastructure-as-code, and proactive monitoring across platforms.",
      social: {
        linkedin: "#",
        twitter: "#",
        github: "#"
      },
      expertise: [
        "Cloud Infrastructure (AWS, Azure)",
        "Infrastructure as Code (Terraform)",
        "CI/CD Pipelines",
        "Containerization (Docker, K8s)",
        "Monitoring & Alerting",
        "Zero-Downtime Deployments",
        "Security Automation",
        "Load Balancing & High Availability",
        "Disaster Recovery Planning"
      ],
      joinYear: 2022,
      funFact: "Ethical hacker who loves Capture-the-Flag competitions"
    },
    {
      name: "Layla Ahmed",
      role: "Product Manager",
      image: "https://res.cloudinary.com/due4nhetn/image/upload/v1751152700/Layla_Ahmed_Product_wmblso.png",
      description: "Strategic product manager with expertise in agile methodologies, feature prioritization, and roadmap planning. Drives product success by blending user insights, technical feasibility, and market trends.",
      social: {
        linkedin: "#",
        twitter: "#",
        medium: "#"
      },
      expertise: [
        "Product Strategy",
        "Agile Methodologies",
        "User Journey Mapping",
        "Market & Competitor Analysis",
        "Feature Roadmapping",
        "MVP Development",
        "Cross-Functional Leadership",
        "User Testing & Feedback Loops",
        "Stakeholder Communication"
      ],
      joinYear: 2022,
      funFact: "Volunteers with women-in-tech initiatives and hosts a tech podcast"
    }
  ];

  const values = [
    {
      title: "Innovation",
      description: "We embrace cutting-edge technologies and methodologies to deliver breakthrough solutions that drive digital transformation.",
      icon: "fas fa-lightbulb",
      color: "from-blue-500 to-cyan-400",
      iconColor: "text-blue-500",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      title: "Quality",
      description: "Every line of code, design element, and user interaction is crafted with meticulous attention to detail and precision.",
      icon: "fas fa-medal",
      color: "from-amber-500 to-yellow-400",
      iconColor: "text-amber-500",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      title: "Collaboration",
      description: "We forge strong partnerships with our clients, working hand-in-hand to achieve exceptional digital outcomes.",
      icon: "fas fa-handshake",
      color: "from-emerald-500 to-teal-400",
      iconColor: "text-emerald-500",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
    {
      title: "Integrity",
      description: "We uphold the highest standards of transparency, honesty, and ethical practices in all our interactions.",
      icon: "fas fa-shield-alt",
      color: "from-violet-500 to-purple-400",
      iconColor: "text-violet-500",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    },
  ];
  

  return (
    <>
      <SEO
        title="About Web Design UAE | Website, App & Software Company – ZeeXSoft"
        description="ZeeXSoft: Founded in 2017, we've grown from a small Sharjah startup to a leading UAE software development firm. Our team of 50+ experts specializes in custom solutions for businesses across the Middle East."
        keywords="about ZeeXSoft, software company UAE, tech team Sharjah, digital transformation UAE"
      />

      {/* Hero Section */}
      <section className="relative pt-40 pb-28 overflow-hidden bg-gradient-to-b from-background to-muted/5">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/5 to-transparent"></div>
          <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
        </div>
        <div className="container relative z-10 px-6 mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-4xl mx-auto text-center"
          >
            <motion.span 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="inline-block px-4 py-2 mb-6 text-sm font-medium tracking-widest text-primary uppercase rounded-full bg-primary/10"
            >
              Our Journey
            </motion.span>
            <motion.h1 
              className="mb-6 text-5xl font-bold md:text-6xl lg:text-7xl font-orbitron bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
            >
              Shaping the Future of Technology
            </motion.h1>
            <motion.p 
              className="max-w-3xl mx-auto text-xl md:text-2xl text-muted-foreground"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              We are a team of passionate technologists dedicated to architecting tomorrow's digital solutions, today.
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Our Story */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-background to-transparent"></div>
          <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-background to-transparent"></div>
        </div>
        
        <div className="container px-6 mx-auto">
          <div className="grid items-center grid-cols-1 gap-16 lg:grid-cols-2">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
              className="relative"
            >
              <div className="relative z-10 p-1 bg-gradient-to-br from-primary/20 to-secondary/20 rounded-2xl">
                <div className="overflow-hidden rounded-xl">
                  <img
                    src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&h=800"
                    alt="ZeeXSoft team working"
                    className="w-full h-auto transition-transform duration-700 hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full -z-10"></div>
              <div className="absolute -top-6 -left-6 w-40 h-40 bg-secondary/10 rounded-full -z-10"></div>
              
              <div className="grid grid-cols-2 gap-6 mt-12">
                <div className="p-6 rounded-xl bg-card/50 backdrop-blur-sm border border-border/50">
                  <div className="text-4xl font-bold text-primary">50+</div>
                  <div className="mt-2 text-sm font-medium text-muted-foreground">Projects Delivered</div>
                </div>
                <div className="p-6 rounded-xl bg-card/50 backdrop-blur-sm border border-border/50">
                  <div className="text-4xl font-bold text-secondary">99%</div>
                  <div className="mt-2 text-sm font-medium text-muted-foreground">Client Satisfaction</div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="max-w-lg mx-auto lg:mx-0 lg:max-w-none">
                <motion.span 
                  className="inline-block text-primary font-medium mb-3 tracking-widest text-sm uppercase"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  Our Story
                </motion.span>
                
                <motion.h2 
                  className="mb-6 text-4xl font-bold md:text-5xl font-orbitron"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  viewport={{ once: true }}
                >
                  Building the Future, <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">One Line at a Time</span>
                </motion.h2>
                
                <div className="space-y-6">
                  <motion.p 
                    className="text-lg text-muted-foreground"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    viewport={{ once: true }}
                  >
                    Founded in 2019 in the vibrant business hub of Sharjah, UAE, ZeeXSoft began with a simple yet ambitious vision: to bridge the gap between innovative technology and practical business solutions.
                  </motion.p>
                  
                  <motion.p 
                    className="text-lg text-muted-foreground"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    viewport={{ once: true }}
                  >
                    What started as a small team of passionate developers has grown into a comprehensive technology partner for businesses across the UAE and beyond. We've successfully delivered over 50 projects, ranging from simple websites to complex enterprise solutions.
                  </motion.p>
                  
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 }}
                    viewport={{ once: true }}
                    className="pt-4"
                  >
                    <Button asChild className="px-8 py-6 text-lg group">
                      <Link href="/about#team" className="flex items-center">
                        Meet Our Team
                        <i className="ml-2 transition-transform fas fa-arrow-right group-hover:translate-x-1"></i>
                      </Link>
                    </Button>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Core Vision Section */}
      <section className="py-20 bg-gradient-to-b from-background to-muted/5 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full mix-blend-multiply filter blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/20 rounded-full mix-blend-multiply filter blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-6 relative">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-4xl mx-auto mb-16"
          >
            <span className="inline-block text-primary font-medium mb-3 tracking-widest text-sm uppercase">Our Vision</span>
            <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-6">
              Shaping the Future of <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">Digital Innovation</span>
            </h2>
            <p className="text-xl text-muted-foreground">
              At ZeeXSoft, we don't just follow technology trends – we create them. Our vision is to be the catalyst for digital transformation, 
              empowering businesses to thrive in an ever-evolving digital landscape.
            </p>
          </motion.div>

          {/* Core Values */}
          <div className="relative">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value: { title: string; description: string; icon: string; color: string; iconColor: string; image: string }, index: number) => (
                <motion.div
                  key={value.title}
                  initial={{ opacity: 0, y: 50, scale: 0.95 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  whileHover={{ y: -10 }}
                  transition={{ 
                    duration: 0.5, 
                    delay: index * 0.1,
                    type: "spring",
                    stiffness: 100
                  }}
                  viewport={{ once: true, margin: "-50px" }}
                  className="group relative bg-card/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-border/50 hover:border-primary/30"
                >
                  <div className="absolute inset-0 overflow-hidden rounded-2xl">
                    <img 
                      src={value.image}
                      alt={value.title}
                      className="w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity duration-500"
                      loading="lazy"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-br ${value.color}/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                  </div>
                  
                  <div className="relative z-10">
                    <motion.div 
                      className="relative"
                      initial={{ scale: 0.9, opacity: 0.8 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      whileHover={{ scale: 1.1, rotate: 5 }}
                      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                    >
                      <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-card to-card/80 backdrop-blur-sm border border-border/50 flex items-center justify-center group-hover:shadow-lg transition-all duration-500">
                        {value.title === "Innovation" && <InnovationIcon className="w-10 h-10" primaryColor={value.iconColor} />}
                        {value.title === "Quality" && <QualityIcon className="w-10 h-10" primaryColor={value.iconColor} />}
                        {value.title === "Collaboration" && <CollaborationIcon className="w-10 h-10" primaryColor={value.iconColor} />}
                        {value.title === "Integrity" && <IntegrityIcon className="w-10 h-10" primaryColor={value.iconColor} />}
                      </div>
                    </motion.div>
                    
                    <h3 className="text-2xl font-bold text-center mb-4 group-hover:bg-clip-text group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-primary group-hover:to-secondary transition-all">
                      {value.title}
                    </h3>
                    
                    <p className="text-muted-foreground text-center">
                      {value.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
            
            {/* Vision Statement */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              viewport={{ once: true }}
              className="mt-20 bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8 md:p-12 relative overflow-hidden"
            >
              <div className="absolute inset-0 opacity-5">
                <div className="absolute -top-20 -right-20 w-64 h-64 bg-primary rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
              </div>
              
              <div className="relative z-10 max-w-4xl mx-auto text-center">
                <div className="w-16 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mb-8 rounded-full"></div>
                <h3 className="font-orbitron font-bold text-2xl md:text-3xl mb-6">
                  Our Commitment to Excellence
                </h3>
                <p className="text-lg text-muted-foreground mb-8">
                  We're dedicated to pushing the boundaries of what's possible, delivering exceptional value, and building lasting relationships with our clients. 
                  Our commitment to excellence is reflected in every project we undertake and every solution we deliver.
                </p>
                <Button asChild className="px-8 py-6 text-lg group">
                  <Link href="/contact">
                    Partner With Us
                    <i className="fas fa-arrow-right ml-2"></i>
                  </Link>
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gradient-to-b from-background to-muted/10 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute -top-32 -right-32 w-64 h-64 bg-primary rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
          <div className="absolute -bottom-16 -left-16 w-64 h-64 bg-secondary rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-accent rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <span className="inline-block text-primary font-medium mb-3 tracking-widest text-sm uppercase">OUR TEAM</span>
              <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                Meet Our Expert Team
              </h2>
              <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mb-6 rounded-full"></div>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                A diverse team of passionate professionals dedicated to delivering exceptional results
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                whileHover={{ y: -10 }}
                transition={{ 
                  duration: 0.5, 
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 100
                }}
                viewport={{ once: true, margin: "-100px" }}
                className="group relative bg-card/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-border/50 hover:border-primary/30"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="w-40 h-40 mx-auto mb-6 rounded-full overflow-hidden border-4 border-primary/20 group-hover:border-primary/50 transition-all duration-500 relative">
                    <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  
                  <div className="text-center">
                    <h3 className="text-2xl font-bold mb-1 group-hover:text-primary transition-colors">
                      {member.name}
                      <span className="block text-sm font-normal text-muted-foreground mt-1">
                        Since {member.joinYear}
                      </span>
                    </h3>
                    
                    <p className="text-primary/80 font-medium mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                      {member.role}
                    </p>
                    
                    <p className="text-muted-foreground mb-5 min-h-[60px] text-sm leading-relaxed">
                      {member.description}
                    </p>
                    
                    <div className="mb-5">
                      <div className="flex flex-wrap justify-center gap-2 mb-4">
                        {member.expertise.map((skill, i) => (
                          <motion.span 
                            key={i} 
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ delay: 0.1 * i }}
                            className="text-xs bg-muted/50 hover:bg-muted px-3 py-1 rounded-full border border-border transition-colors cursor-default"
                          >
                            {skill}
                          </motion.span>
                        ))}
                      </div>
                      
                      <div className="text-xs text-muted-foreground italic">
                        <i className="fas fa-lightbulb mr-1"></i> {member.funFact}
                      </div>
                    </div>
                    
                    <div className="flex justify-center space-x-3 mt-6 pt-4 border-t border-border/50">
                      {Object.entries(member.social).map(([platform, url]) => (
                        <motion.a 
                          key={platform} 
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          whileHover={{ y: -3, scale: 1.1 }}
                          whileTap={{ scale: 0.95 }}
                          className="w-10 h-10 rounded-full bg-muted/50 hover:bg-primary/10 flex items-center justify-center text-muted-foreground hover:text-primary transition-colors border border-border/50 hover:border-primary/30"
                          aria-label={`${member.name}'s ${platform}`}
                        >
                          <i className={`fab fa-${platform} text-lg`}></i>
                        </motion.a>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: true, margin: "-50px" }}
            className="relative mt-24 mb-16"
          >
            {/* Decorative elements */}
            <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-gradient-to-r from-primary/10 to-secondary/10 blur-2xl"></div>
            <div className="absolute -bottom-12 right-1/4 w-16 h-16 rounded-full bg-accent/10 blur-xl"></div>
            
            <div className="relative bg-gradient-to-br from-card to-card/80 rounded-2xl p-1 shadow-2xl">
              <div className="bg-gradient-to-br from-background to-background/90 rounded-xl p-8 md:p-12">
                <div className="max-w-4xl mx-auto">
                  <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    <div className="text-left">
                      <h3 className="font-orbitron font-bold text-2xl md:text-3xl mb-3 bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                        Ready to Join Our Team?
                      </h3>
                      <p className="text-muted-foreground text-lg max-w-2xl">
                        We're looking for passionate individuals who want to make an impact. Join us in shaping the future of technology.
                      </p>
                    </div>
                    
                    <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                      <Button 
                        asChild 
                        className="px-8 py-6 text-lg bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-all hover:-translate-y-0.5 shadow-lg hover:shadow-primary/20"
                      >
                        <Link href="/careers" className="group">
                          View Open Positions
                          <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                        </Link>
                      </Button>
                      <Button 
                        asChild
                        variant="outline"
                        className="px-8 py-6 text-lg border-border/50 hover:border-primary/50 hover:bg-primary/5 transition-all"
                      >
                        <Link href="/careers#team" className="group">
                          Meet the Team
                          <i className="fas fa-users ml-2 group-hover:translate-x-1 transition-transform"></i>
                        </Link>
                      </Button>
                    </div>
                  </div>
                  
                  <div className="mt-8 pt-8 border-t border-border/20 flex flex-wrap justify-center gap-4">
                    {['Innovation', 'Collaboration', 'Growth', 'Impact'].map((tag, i) => (
                      <motion.span
                        key={tag}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 * i, duration: 0.3 }}
                        className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-muted/50 text-muted-foreground border border-border/30"
                      >
                        <i className="fas fa-check-circle text-primary mr-2"></i>
                        {tag}
                      </motion.span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary/10 to-accent/10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="container mx-auto px-6 text-center"
        >
          <h2 className="font-orbitron font-bold text-4xl mb-6">Ready to start your project?</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Let's discuss how we can help you achieve your business goals with our technology expertise.
          </p>
          <Button asChild className="px-8 py-6 text-lg">
            <Link href="/contact">Get in Touch</Link>
          </Button>
        </motion.div>
      </section>
    </>
  );
}
